import type { ReactNode } from 'react'
import React from 'react'

import { ButtonGroup, DashboardLogo } from '@fourthwall/components'

import { routing } from '../../../../utils/routing'
import * as S from './styled'

export type IframePreviewProps = {
  headline: string
  status: ReactNode
  buttons: ReactNode
  dropdown?: ReactNode
  iframeSrc: string
}

export const IframePreview = ({
  headline,
  status,
  buttons,
  dropdown,
  iframeSrc,
}: IframePreviewProps) => (
  <S.Container>
    <S.HeaderDesktop>
      <S.HeaderLogo>
        <DashboardLogo to={routing.home.toString()} color="inherit" />
      </S.HeaderLogo>
      <S.Headline>
        <h4>{headline}</h4> {status}
      </S.Headline>
      <S.HeaderButtons>
        <ButtonGroup space="large">
          {buttons}
          {dropdown}
        </ButtonGroup>
      </S.HeaderButtons>
    </S.HeaderDesktop>

    <S.HeaderMobile>
      <S.MobileTop>
        <DashboardLogo to={routing.home.toString()} color="inherit" />
        {dropdown}
      </S.MobileTop>
      <S.MobileHeadline>
        {headline} <div style={{ display: 'inline-block', marginLeft: '4px' }}>{status}</div>
      </S.MobileHeadline>
      <S.MobileButtons>
        <ButtonGroup space="medium">{buttons}</ButtonGroup>
      </S.MobileButtons>
    </S.HeaderMobile>
    <div>
      <S.PreviewIframe src={iframeSrc} />
    </div>
  </S.Container>
)
